import axios from '../../utilities/axios';
import { ofType } from 'redux-observable';
import { of, merge } from 'rxjs';
import { mergeMap, switchMap, catchError } from 'rxjs/operators';
import { primaryApi } from '../../utilities/apiEndpointUtility';
import {
	failureMessage,
	successMessage
} from '../Notifications/notificationsSlice';

import i18n from '../../i18n';

import {
	createProject,
	createProjectCompleted,
	createProjectFailed
} from './projectSlice';

export const createProjectEpic = (action$, state$) =>
	action$.pipe(
		ofType(createProject.type),
		mergeMap(async (action) => {
			try {
				const payload = action.payload;
				const formData = new FormData();

				if (payload.thumbnail) {
					formData.append('file', payload.thumbnail);
				}

				delete action.payload.thumbnail;

				for (const [key, value] of Object.entries(action.payload)) {
					formData.append(key, value);
				}

				const response = await axios.post(
					`${primaryApi()}/api/v1/project`,
					formData,
					{
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					}
				);

				return response.data;
			} catch (e) {
				return {
					error: e.message
				};
			}
		}),
		switchMap((res) => {
			return [
				createProjectCompleted(res),
				successMessage(i18n.t('notifications:createProjectSuccess'))
			];
		}),
		catchError((error, source) => {
			return merge(
				of(createProjectFailed(error.message), failureMessage(error.message)),
				source
			);
		})
	);

export default [createProjectEpic];
